import AppEvents from 'Shared/app-events';
import ds from 'Shared/ds';

export default class ContactApi {

    static #onChanged = (result) => AppEvents.emit(this.Events.CONTACT_CHANGED, result);

    static productRequest = async (productId) => await ds
        .post(this.#const.PRODUCT_REQUEST, {
            ProductId: productId
        });

    static #const = {
        ProductRequest: "product-request"
    };

    static Events = {
        PRODUCT_REQUEST: "product-request",
        GENERAL_REQUEST: "general-request",
        CONTACT_CHANGED: "contact-changed"
    };
}